
<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script setup >
// props="['width','height','right1Data']"
import { ref, onMounted,defineProps,watchEffect } from "vue";
import * as echarts from "echarts";
const props =defineProps({
  width: {
    type: String,
    default: "100%",
  },
  height: {
    type: String,
    default: "100%",
  },
  listData: {
    type: Array,
    default: () => [],
  },
  listData1: {
    type: Array,
    default: () => [],
  },
})
// console.log(props.leftData2);
const myEcharts = ref(null);

onMounted(() => {

  initChart(props.listData,props.listData1);
});


function initChart(listData,listData1) {
  if (myEcharts.value && myEcharts.value.chart) {
    myEcharts.value.chart.dispose();
  }

  const chartInstance = echarts.init(myEcharts.value);

  let xLabel = listData.time
  let dataValue = listData.data;
  let dataValue1 = listData1.data;
  // console.log(listData.color[0])
  const option= {
    tooltip: {
      trigger: "axis",
      axisPointer: {
        lineStyle: {
          color: "rgb(126,199,255)",
        },
      },
    },
    legend: {
      show: true,
      icon: "rect",
      top: "5%",
      right: "5%",
      itemWidth: 20, // 图例标记的图形宽度。
      //   itemGap: 20, // 图例每项之间的间隔。
      itemHeight: 10, //  图例标记的图形高度。
      textStyle: {
        color: "#fff",
        fontSize: 26,
        padding: [0, 8, 0, 8],
      },
    },
    title: {
      text: "单位：元/斤",
      // subtext: "13000吨",

      textStyle: {
        color: "#f2f2f2",
        fontSize: 26,
        fontWeight:"normal"
      },
      subtextStyle: {
        fontSize: 30,

        color: ["#ff9d19"],
      },

      x: "5%",
      y: "5%",
    },
    grid: {
      top: "18%",
      left: "10%",
      right: "5%",
      bottom: "10%",
    },
    xAxis: [
      {
        type: "category",
        boundaryGap: false,
        axisLine: {
          //坐标轴轴线相关设置。数学上的x轴
          show: true,
          lineStyle: {
            color: "rgba(255,255,255,.3)",
            type: "solid",
            width: 5,
          },
        },
        axisLabel: {
          //坐标轴刻度标签的相关设置
          textStyle: {
            color: "rgba(255,255,255,.8)",
            fontSize: 26,
            fontWeight:"normal",
            padding:[10,0,0,0]
          },
        },
        splitLine: {
          show: false,
          lineStyle: {
            color: "#233653",
          },
        },
        axisTick: {
          show: false,
        },
        data: xLabel,
      },
    ],
    yAxis: [
      {
        name: "",
        splitNumber: 3,
        nameTextStyle: {
          color: "#fff",
          fontSize: 26,
          padding: [0, 60, 0, 0],
        },
        // minInterval: 1,
        type: "value",
        splitLine: {
          show: true,
          lineStyle: {
            color: "rgba(255,255,255,.3)",
            type: "dashed",
          },
        },
        axisLine: {
          show: false,
          lineStyle: {
            color: "#008de7",
          },
        },
        axisLabel: {
          show: true,
          textStyle: {
            color: "rgba(255,255,255,.8)",
            fontSize: 26,
            padding:[0,10,0,0]
          },
          formatter: function(value) {
            // 当值为 0 时不显示标签
            return value == 0 ? '' : value;
          }
        },
        axisTick: {
          show: false,
        },
      },
    ],
    series: [
      {
        name: "红薯粉丝",
        type: "line",
        symbol: "circle", // 默认是空心圆（中间是白色的），改成实心圆
        smooth: true,
        lineStyle: {
          normal: {
            width: 3,
            color: listData.color[0], // 线条颜色
          },
        },
        itemStyle: {
          normal: {
            color: listData.color[0], //拐点颜色
            // borderColor: 'listData.color[0]',//拐点边框颜色
            // borderWidth: 13//拐点边框大小
          },
        },
        symbolSize: 9, //设定实心点的大小
        areaStyle: {
          normal: {
            //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
            color: new echarts.graphic.LinearGradient(
              0,
              0,
              0,
              1,
              [
                {
                  offset: 0,
                  color: listData.color[3],
                },
                {
                  offset: 0.6,
                  color: listData.color[2],
                },
                {
                  offset: 1,
                  color: listData.color[1],
                },
              ],
              false
            ),
          },
        },
        data: dataValue,
      },{
        name: "红薯粉条",
        type: "line",
        symbol: "circle", // 默认是空心圆（中间是白色的），改成实心圆
        smooth: true,
        lineStyle: {
          normal: {
            width: 3,
            color: listData1.color[0], // 线条颜色
          },
        },
        itemStyle: {
          normal: {
            color: listData1.color[0], //拐点颜色
            // borderColor: 'listData.color[0]',//拐点边框颜色
            // borderWidth: 13//拐点边框大小
          },
        },
        symbolSize: 9, //设定实心点的大小
        areaStyle: {
          normal: {
            //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
            color: new echarts.graphic.LinearGradient(
              0,
              0,
              0,
              1,
              [
                {
                  offset: 0,
                  color: listData.color[3],
                },
                {
                  offset: 0.6,
                  color: listData.color[2],
                },
                {
                  offset: 1,
                  color: listData.color[1],
                },
              ],
              false
            ),
          },
        },
        data: dataValue1,
      },
    ],
  };// 将你的ECharts配置项放在这里
  chartInstance.setOption(option);

}
window.addEventListener("resize", () => {
  chartInstance.resize();
});

</script>
<style lang="less"></style>
